import { TFunction } from 'i18next';
import {
  DataPoint,
  MonetaryAmount,
  MonetaryAmountDataPoint,
  RecurringFrequency,
  StringDataPoint,
} from '../generated/graphql';

export const recurringMonetaryAmountDataPointValue = (dataPoint: DataPoint | undefined | null) => {
  if (dataPoint?.data.__typename === 'RecurringMonetaryAmountDataPointValue') {
    return dataPoint.data.value;
  }
};

export function monetaryAmountDataPointValue(dataPoint: DataPoint | undefined | null) {
  if (dataPoint?.data?.__typename === 'MonetaryAmountDataPointValue') {
    return dataPoint.data.value;
  }
}

export function ownedValueDataPointValue(dataPoint: MonetaryAmount | undefined | null) {
  if (dataPoint?.__typename === 'MonetaryAmount') {
    return dataPoint;
  }
}

export function investmentMixDataPointValue(dataPoint: DataPoint | undefined | null) {
  if (dataPoint?.data?.__typename === 'InvestmentMixDataPointValue') {
    return dataPoint.data.value;
  }
}

export function floatDataPointValue(dataPoint: DataPoint | undefined | null) {
  if (dataPoint?.data?.__typename === 'FloatDataPointValue') {
    return dataPoint.data.value;
  }
}

/**
 * @description Returns the scalar `value` carried by every non-custom DataPointValue variant. CustomDataPointValue carries `entries` instead of `value` and yields undefined.
 */
export function dataPointScalarValue(data: object | null | undefined): unknown {
  if (data && 'value' in data) {
    return (data as { value: unknown }).value;
  }
  return undefined;
}

/**
 * @description Returns the items of any DataPointList variant selected in the query, or an empty array when the variant's items were not selected (e.g. an unselected CustomDataPointList).
 */
export function dataPointListItems(list: object | null | undefined): unknown[] {
  if (list && 'items' in list) {
    const items = (list as { items: unknown }).items;
    return Array.isArray(items) ? items : [];
  }
  return [];
}

export function isMonetaryAmount(amount: unknown): amount is MonetaryAmount {
  return (<MonetaryAmount>amount)?.__typename === 'MonetaryAmount';
}

export function isMonetaryAmountDataPoint(
  dataPoint: DataPoint | undefined | null
): dataPoint is MonetaryAmountDataPoint {
  return dataPoint?.data?.__typename === 'MonetaryAmountDataPointValue';
}

export function isStringDataPoint(dataPoint: DataPoint | undefined | null): dataPoint is StringDataPoint {
  return dataPoint?.data?.__typename === 'StringDataPointValue';
}

/**
 *
 * @description Types DataPoint[] to MonetaryAmountDataPoint[] by filtering out non-MonetaryAmountDataPoint values given dataPoint.data.__typename === 'MonetaryAmountDataPointValue'
 */
export function getTypedMonetaryAmountDataPoints(dataPoints: DataPoint[]): MonetaryAmountDataPoint[] {
  return dataPoints.filter((dataPoint) => isMonetaryAmountDataPoint(dataPoint));
}

export function getTypedStringDataPoints(dataPoints: DataPoint[] | undefined): StringDataPoint[] {
  return dataPoints?.filter((dataPoint) => isStringDataPoint(dataPoint)) || [];
}

export function recurringFrequencyToPaymentFrequencySuffix(
  frequency: RecurringFrequency | undefined | null,
  tCommon: TFunction<'common'>
) {
  switch (frequency) {
    case RecurringFrequency.Annually:
      return tCommon('yearly-frequency-suffix');
    case RecurringFrequency.Monthly:
      return tCommon('monthly-frequency-suffix');
    case RecurringFrequency.Biweekly:
      return tCommon('biweekly-frequency-suffix');
    case RecurringFrequency.Quarterly:
      return tCommon('quarterly-frequency-suffix');
    case RecurringFrequency.Unknown:
    default:
      return '';
  }
}
